
import { SearchCard as SearchCardType } from '@/lib/types';
import { Card } from '@/components/ui/card';

interface SearchCardProps {
  card: SearchCardType;
  onClick: () => void;
}

export function SearchCard({ card, onClick }: SearchCardProps) {
  return (
    <Card
      className={`p-4 cursor-pointer transition-all hover:shadow-md h-full ${
        !card.enabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      onClick={() => card.enabled && onClick()}
    >
      <div className="flex flex-col space-y-2">
        <div className={`w-10 h-10 rounded-lg ${card.iconBg} flex items-center justify-center text-xl`}>
          {card.icon}
        </div>
        <h3 className="font-bold text-base text-gray-900">{card.title}</h3>
        <p className="text-sm font-casual text-gray-600 leading-relaxed">{card.description}</p>
      </div>
    </Card>
  );
}
